import { Tag } from '@procurify/ui'
import styled from 'styled-components'

export const HighlightableTagStyled = styled(Tag)<{ $isHighlighted: boolean }>`
  background-color: ${(props) =>
    props.$isHighlighted ? props.theme.colors.focus : 'transparent'};
  border: 1px solid ${(props) => props.theme.colors.form.field.border};
`
